import { keysTypeMap } from './keys';
export * from './keys';
/**
 * Maps solana beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */
export const supportedTypeMap = keysTypeMap;
//# sourceMappingURL=beet-solana.js.map